import {getConfig} from 'config';
import {getData} from '../dataProvider';

export const loadContextHelp = () => {
  return getData(`${getConfig('contextHelpUrl')}`);
};
